import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { UserCog, LogOut } from "lucide-react";

// Persistent banner shown while an admin is impersonating another user.
export default function ImpersonationBanner() {
  const { user, stopImpersonation } = useAuth();
  const nav = useNavigate();
  const [leaving, setLeaving] = useState(false);
  if (!user || !user.impersonated_by) return null;

  const back = async () => {
    setLeaving(true);
    try {
      await stopImpersonation();
      toast.success("Back to your admin account.");
      nav("/admin", { replace: true });
    } catch {
      toast.error("Could not switch back. Please log in again.");
    } finally { setLeaving(false); }
  };

  return (
    <div data-testid="impersonation-banner"
      className="sticky top-0 z-[80] flex items-center justify-center gap-3 px-4 py-2 text-sm font-semibold text-white"
      style={{ background: "#B23A28" }}>
      <UserCog size={16} />
      <span>Viewing as <span className="underline">{user.name || user.email}</span> ({user.role})</span>
      <button data-testid="stop-impersonation-btn" onClick={back} disabled={leaving}
        className="ml-2 inline-flex items-center gap-1 rounded-full bg-white/20 px-3 py-1 hover:bg-white/30 transition-colors">
        <LogOut size={14} /> {leaving ? "Switching…" : "Return to admin"}
      </button>
    </div>
  );
}
